import { t } from "../../i18n";
import { Globe2 } from "lucide-react";
import { asRecord } from "./ToolResultView.utils";
import { Card } from "./OperationResultCard";
import { Heading } from "./OperationResultHeading";
import { titleCase } from "./OperationResult.utils";

export function BusinessRows({
  operation,
  entries,
}: {
  operation: string;
  entries: unknown[];
}) {
  return (
    <Card tone="stone">
      <Heading
        icon={
          <Globe2 size={16} className="text-lumen-700 dark:text-lumen-300" />
        }
      >
        {titleCase(operation || "Business integration")}
      </Heading>
      <div className="mt-3 overflow-x-auto rounded-xl border border-stone-200 dark:border-white/10">
        <div className="min-w-[28rem] divide-y divide-stone-200 dark:divide-white/10">
          {entries.slice(0, 20).map((item, index) => {
            const row = asRecord(item);
            return (
              <div
                key={index}
                className="grid gap-1 px-3 py-2.5 text-xs sm:grid-cols-3"
              >
                {row ? (
                  Object.entries(row)
                    .slice(0, 3)
                    .map(([key, value]) => (
                      <div key={key} className="min-w-0">
                        <div className="text-[10px] font-semibold text-stone-400 uppercase">
                          {titleCase(key)}
                        </div>
                        <div className="truncate text-stone-700 dark:text-stone-200">
                          {typeof value === "object"
                            ? JSON.stringify(value)
                            : String(value ?? "—")}
                        </div>
                      </div>
                    ))
                ) : (
                  <div>{String(item)}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {entries.length > 20 && (
        <p className="mt-2 text-xs text-stone-500">
          {t("Showing the first {{count}} results", { count: 20 })}
        </p>
      )}
    </Card>
  );
}
